<template>
  <div
    :class="!$vuetify.breakpoint.mobile ? (styleEntete ? 'w-140' : '') : ''"   
  >
    <div
      v-if="value"   
      class="d-flex"   
      :class="$vuetify.breakpoint.mobile ? 'ml-3 flex-column' : ''"
    >
      <span
        v-if="label"
        class="intro mr-2"
        :class="!$vuetify.breakpoint.mobile ? 'align-self-center' : ''"
      >  {{ label }} </span>       
      <div :class="!$vuetify.breakpoint.mobile ? 'align-self-center' : ''">
        <v-icon
          v-if="icon && icon.display"
          :class="customClass"
        >
          {{ icon.name }}
        </v-icon>
        <span :class="customClass">
          {{ value | roundNumber(precision) }}
        </span>
        <span :class="customClass">
          {{ unit }}
        </span>      
      </div>
    </div>
    <div
      v-else
      class="d-flex align-content-center"
    >
      <span
        v-if="label"
        class="intro mr-2"
        :class="!$vuetify.breakpoint.mobile ? 'align-self-center' : ''"
      >  {{ label }} </span>
      <BaseTooltipNoData
        :message="message"
        :is-dark="isDark"
      />
    </div>  
  </div>
</template>

<script>
import BaseTooltipNoData from './base-tooltip-no-data.vue'
export default {
  name: 'BaseDataV2',
  components: { BaseTooltipNoData },
  props: {
    label: {
      type: String,
      default: null
    },
    value: {
      type: [Number, String, Boolean],
      default: null
    },
    unit: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    precision: {
      type: Number,
      default: 0
    },    
    isDark: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },
    styleEntete: {
      type: Boolean,
      default: true
    },
    icon: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.w-140 {
  width: 140px;
}
</style>
